import type { V3LogDetail } from './categories'
import type { Solution } from './solutionHandlers'

export interface WarningLine {
  subheader: string | null
  message: string
  category: string | null
  solutions: Solution[]
}

export function warningView(detail: V3LogDetail): WarningLine[] {
  if (detail.category !== 'success') return []

  if (detail.warning_details?.length) {
    return detail.warning_details.map((warning) => {
      const mappingError =
        warning.type === 'reverse_update_failed' ? warning.mapping_error : null
      return {
        subheader: warning.subheader ?? null,
        message: warning.message,
        category: mappingError?.subheader ?? null,
        solutions: mappingError?.solutions ?? [],
      }
    })
  }

  return (detail.warnings ?? []).map((message) => ({
    subheader: null,
    message,
    category: null,
    solutions: [],
  }))
}
